module.exports = __webpack_public_path__ + "img/160x130.44a55023.png";